<div
  class="srpredisposition-card"
  role="button"
  tabindex="0"
  (click)="openServiceRequest()"
  (keydown.enter)="openServiceRequest()"
  (keydown.space)="openServiceRequest()"
>
  <span class="result-status-badge" *ngIf="srpredisposition.hasUnseenResult">
    {{ "common.new" | translate }}
  </span>

  <div class="srpredisposition-inner">
    <!-- Info -->
    <div class="srpredisposition-info">
      <div class="srpredisposition-info-left">
        <h3 class="srpredisposition-title">{{ srpredisposition.title }}</h3>
        <div class="srpredisposition-meta-item" *ngIf="srpredisposition.latestResult">
          <span class="srpredisposition-meta-label">{{ "common.date" | translate }}:</span>
          <span class="srpredisposition-meta-value">
            {{ srpredisposition.latestResult.date | localizedDate: "dd MMMM yyyy" }}
          </span>
        </div>

        <div class="srpredisposition-result" *ngIf="result">
          <div class="result-item" *ngIf="result.valueQuantity">
            <span class="srpredisposition-meta-label">{{ "page.home.predispositions.result.quantity" | translate }}:</span>
            <span class="srpredisposition-meta-value"> {{ result.valueQuantity.value }} {{ result.valueQuantity.unit }} </span>
          </div>

          <div class="result-item" *ngIf="result.valueString !== undefined && result.valueString !== null">
            <span class="srpredisposition-meta-label">{{ "page.home.predispositions.result.note" | translate }}:</span>
            <span class="srpredisposition-meta-value">{{ result.valueString }}</span>
          </div>

          <div class="result-item" *ngIf="result.valueBoolean !== undefined && result.valueBoolean !== null">
            <span class="srpredisposition-meta-label">{{ "page.home.predispositions.result.result" | translate }}:</span>
            <span class="srpredisposition-meta-value">
              {{ result.valueBoolean ? ("common.yes" | translate) : ("common.no" | translate) }}
            </span>
          </div>

          <div class="result-item" *ngIf="result.valueInteger !== undefined && result.valueInteger !== null">
            <span class="srpredisposition-meta-label">{{ "page.home.predispositions.result.score" | translate }}:</span>
            <span class="srpredisposition-meta-value">{{ result.valueInteger }}</span>
          </div>

          <div class="result-item" *ngIf="result.valueRange">
            <span class="srpredisposition-meta-label">{{ "page.home.predispositions.result.range" | translate }}:</span>
            <span class="srpredisposition-meta-value">
              {{ result.valueRange.low.value }} {{ result.valueRange.low.unit }}
              –
              {{ result.valueRange.high.value }} {{ result.valueRange.high.unit }}
            </span>
          </div>

          <div class="result-item" *ngIf="result.valueRatio">
            <span class="srpredisposition-meta-label"> {{ "page.home.predispositions.result.ratio" | translate }}: </span>
            <span class="srpredisposition-meta-value">
              <ng-container *ngIf="+result.valueRatio.denominator.value === 100; else ratio">
                {{ result.valueRatio.numerator.value }}%
              </ng-container>

              <ng-template #ratio>
                {{ result.valueRatio.numerator.value }} {{ result.valueRatio.numerator.unit }}
                /
                {{ result.valueRatio.denominator.value }} {{ result.valueRatio.denominator.unit }}</ng-template
              >
            </span>
          </div>
        </div>
      </div>
      <div class="srpredisposition-info-right">
        <!-- Status Icon -->
        <mat-icon
          class="srpredisposition-status-icon"
          [style.color]="srpredisposition.status | srStatusColor"
          [matTooltip]="srpredisposition.status | srStatusTooltip | translate"
        >
          {{ srpredisposition.status | srStatusIcon }}
        </mat-icon>
        <!-- Download Button (if results available) -->
        <a
          *ngIf="srpredisposition.latestResult"
          [href]="srpredisposition.latestResult"
          target="_blank"
          class="srpredisposition-download-btn"
          mat-icon-button
          (click)="$event.stopPropagation()"
          [matTooltip]="'common.download' | translate"
          aria-label="Download results"
        >
          <mat-icon>file_download</mat-icon>
        </a>
      </div>
    </div>
  </div>
</div>
